import _regeneratorRuntime from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
/*
 * Created on Wed Jul 18 2018
 */


import { CRUTransportLayer } from '../CRUTransportLayer';
import { ProductCategoryConverter, jsonConversions } from '@logio/common-be-fe';
import { CONSTANTS } from '../../../constants';
import api from '../../api';
import { Inject } from '@logio/typescript-ioc';
/**
 * @author BPo
 */

export var ProductCategoryLayer =
/*#__PURE__*/
function (_CRUTransportLayer) {
  _inherits(ProductCategoryLayer, _CRUTransportLayer);

  function ProductCategoryLayer() {
    _classCallCheck(this, ProductCategoryLayer);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductCategoryLayer).call(this, CONSTANTS.API.ENDPOINTS.CATEGORIES));
  }

  _createClass(ProductCategoryLayer, [{
    key: "getConverter",
    value: function getConverter() {
      return this.converter;
    }
    /**
     * Fetches DTOs for price change report
     * @param filter {PriceChangeReportRequest}
     */

  }, {
    key: "getAllForCurrentUser",
    value: function getAllForCurrentUser() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _this = this;

        var _ref, data;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return api(CONSTANTS.API.ENDPOINTS.CATEGORIES_USER).get();

              case 3:
                _ref = _context.sent;
                data = _ref.data;
                return _context.abrupt("return", (data.result || []).map(function (dto) {
                  return _this.converter.toObject(dto, jsonConversions);
                }));

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", Promise.reject(_context.t0));

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 8]]);
      }));
    }
  }, {
    key: "getCategoryStats",
    value: function getCategoryStats() {
      var getCategoryStatsPromise = api(CONSTANTS.API.ENDPOINTS.PRODUCT_CATEGORY_STATS).get({
        responseType: 'json'
      }).then(function (response) {
        var arr = response.data.result || [];
        return arr;
      });
      return getCategoryStatsPromise;
    }
  }, {
    key: "getManyByIds",
    value: function getManyByIds(categoryIds) {
      var _this2 = this;

      return api("".concat(this.baseUri)).post({
        ids: categoryIds
      }, {
        responseType: 'json'
      }).then(function (response) {
        var arr = [];
        (response.data.result || []).map(function (item) {
          arr.push(_this2.getConverter().toObject(item, jsonConversions));
        });
        return arr;
      });
    }
  }, {
    key: "getForRelease",
    value: function getForRelease(releaseId) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _this3 = this;

        var _ref2, data;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return api(CONSTANTS.API.ENDPOINTS.RELEASE_CATEGORIES(releaseId)).get();

              case 3:
                _ref2 = _context2.sent;
                data = _ref2.data;
                return _context2.abrupt("return", (data.result || []).map(function (dto) {
                  return _this3.converter.toObject(dto, jsonConversions);
                }));

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);
                return _context2.abrupt("return", Promise.reject(_context2.t0));

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 8]]);
      }));
    }
  }, {
    key: "getForSelloutRelease",
    value: function getForSelloutRelease(releaseId) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var _this4 = this;

        var _ref3, data;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return api(CONSTANTS.API.ENDPOINTS.SELLOUT_RELEASE_CATEGORIES(releaseId)).get();

              case 3:
                _ref3 = _context3.sent;
                data = _ref3.data;
                return _context3.abrupt("return", (data.result || []).map(function (dto) {
                  return _this4.converter.toObject(dto, jsonConversions);
                }));

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](0);
                return _context3.abrupt("return", Promise.reject(_context3.t0));

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 8]]);
      }));
    }
  }, {
    key: "getForSiteRelease",
    value: function getForSiteRelease(releaseId) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var _this5 = this;

        var _ref4, data;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return api(CONSTANTS.API.ENDPOINTS.SITE_RELEASE_CATEGORIES(releaseId)).get();

              case 3:
                _ref4 = _context4.sent;
                data = _ref4.data;
                return _context4.abrupt("return", (data.result || []).map(function (dto) {
                  return _this5.converter.toObject(dto, jsonConversions);
                }));

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](0);
                return _context4.abrupt("return", Promise.reject(_context4.t0));

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[0, 8]]);
      }));
    }
  }]);

  return ProductCategoryLayer;
}(CRUTransportLayer);

__decorate([Inject, __metadata("design:type", ProductCategoryConverter)], ProductCategoryLayer.prototype, "converter", void 0);